import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomersService } from '../../../../../services/customers.service';
import { BroadcastService } from '../../../../../shared/services/broadcast.service';
import { FormService } from '../../../../../shared/services/form.service';
import { CustomerModel } from '../models/clients.model';

@Component({
  selector: 'app-create-edit-clients',
  templateUrl: './create-edit-clients.component.html',
  styleUrls: ['./create-edit-clients.component.scss']
})
export class CreateEditClientsComponent implements OnInit, OnDestroy {
  @Input() data: any = {};
  formGroup: RxFormGroup;
  isEdit = false;

  fields: any ={
    name: {
      type: 'input',
      options: {
        path: 'name',
        class: 'col-sm-12',
        label:{
          text: 'Nombre',
          class: 'col-sm-12'
        }
      }
    },
    nombre_comercial: {
      type: 'input',
      options: {
        path: 'nombre_comercial',
        class: 'col-sm-12',
        label:{
          text: 'Nombre Comercial',
          class: 'col-sm-12'
        }
      }
    },
	reels_limit: {
      type: 'input',
      options: {
        path: 'reels_limit',
        class: 'col-sm-12',
        label:{
          text: 'Limite de Reels',
          class: 'col-sm-12'
        }
      }
    },
	units_limit: {
      type: 'input',
      options: {
        path: 'units_limit',
        class: 'col-sm-12',
        label:{
          text: 'Limite de Unidades',
          class: 'col-sm-12'
        }
      }
    },
	media_limit: {
      type: 'input',
      options: {
        path: 'media_limit',
        class: 'col-sm-12',
        label:{
          text: 'Limite de Media',
          class: 'col-sm-12'
        }
      }
    },
	groups_limit: {
      type: 'input',
      options: {
        path: 'groups_limit',
        class: 'col-sm-12',
        label:{
          text: 'Limite de Grupos',
          class: 'col-sm-12'
        }
      }
    },
    razon_social: {
      type: 'input',
      options: {
        path: 'razon_social',
        class: 'col-sm-12',
        label:{
          text: 'Razon Social',
          class: 'col-sm-12'
        }
      }
    },
    active:{
      type: 'switch',
      options:{
        path: 'active',
        label:{
          text: '¿Activo?'
        },
        switchers:{
          trueCaption: 'Si',
          falseCaption: 'No'
        }
      }
    }
  }
  private atComponentDestroy = new Subject();

  constructor(
    private cdr: ChangeDetectorRef,
    public modalRef: BsModalRef,
    private customersService: CustomersService,
    private broadcast: BroadcastService,
    private formService: FormService
  ) {
    this.formService._formEvents
      .pipe(takeUntil(this.atComponentDestroy))
      .subscribe(form => {
        this.formGroup = form;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.atComponentDestroy.next();
    this.atComponentDestroy.unsubscribe();
  }

  ngOnInit(): void {
    this.formService.transformIntoFormGroup(CustomerModel, this.data);

    if (this.data?.id) {
      this.isEdit = true;
      this.formGroup.get('active').setValue(this.data.active);
      this.formGroup.get('name').setValue(this.data.name);
      this.formGroup.get('razon_social').setValue(this.data.razon_social);
      this.formGroup.get('nombre_comercial').setValue(this.data.nombre_comercial);
      this.formGroup.get('units_limit').setValue(this.data.units_limit);
      this.formGroup.get('reels_limit').setValue(this.data.reels_limit);
      this.formGroup.get('media_limit').setValue(this.data.media_limit);
      this.formGroup.get('groups_limit').setValue(this.data.groups_limit);

    }
    this.formGroup.valueChanges
    .pipe(takeUntil(this.atComponentDestroy))
    .subscribe(data => {
      this.cdr.markForCheck();
    });
  }

submit(): void {
	if (!this.formGroup || !this.formGroup.valid) {
		return;
	}

	// Convertir a número dentro del mismo FormGroup
	this.formGroup.get('reels_limit')?.setValue(parseInt(this.formGroup.get('reels_limit')?.value, 10));
	this.formGroup.get('units_limit')?.setValue(parseInt(this.formGroup.get('units_limit')?.value, 10));
	this.formGroup.get('media_limit')?.setValue(parseInt(this.formGroup.get('media_limit')?.value, 10));
	this.formGroup.get('groups_limit')?.setValue(parseInt(this.formGroup.get('groups_limit')?.value, 10));

	// Enviar el FormGroup directamente
	this.customersService.createOrUpdate(this.formGroup, this.data?.id)
		.pipe(takeUntil(this.atComponentDestroy))
		.subscribe(data => {
			this.broadcast.reloadDataTable();
			this.modalRef.hide();
		}, error => {
			console.error("Error al enviar los datos:", error);
		});
}




  toArray(enumme): any[] {
		return Object.keys(enumme)
			.map(key => ({ id: key, name: enumme[key] }));
	}
}
